<template>
    <!-- 선택한 옵션 그룹 -->
    <page-section v-if="carts.length != 0" class="page-section--xs pb-0">
        <template #containerImmersive>
            <!-- 옵션 박스 -->
            <div v-for="(cart, index) in carts" :key="index" :class="{ 'mt-4px mt-md-8px': index != 0 }">
                <shop-product-carts-item v-model="carts[index]" @input="emit" @pull="pull(index)" />
            </div>
        </template>
    </page-section>
</template>

<script>
import PageSection from "@/components/client/templates/page-section.vue";
import ShopProductCartsItem from "./shop-product-carts-item.vue";

export default {
    components: {
        PageSection,
        ShopProductCartsItem,
    },
    props: {
        value: { type: Array, default: () => [] }, // selected
    },
    data: () => ({
        carts: [],
    }),
    computed: {
        userIsLoggedIn() {
            return !!this.$store.state?.payload?._user;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.carts = [...this.value];
        },
        emit() {
            this.$emit("input", this.carts);
        },
        pull(index) {
            this.carts.splice(index, 1);
            this.emit();
        },
    },
};
</script>
